import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { setOrigin } from "../ssrh/client";

import "ckeditor5/dist/ckeditor5-content.css";
import "react-responsive-modal/styles.css";

import App from "./App";

const rootElement = document.getElementById("root") as HTMLElement;

if (process.env.NODE_ENV === "development") {
    setOrigin("http://localhost:1020"); // development server
    createRoot(rootElement).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
} else {
    hydrateRoot(rootElement, <App />);
}
